import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { API_ROUTES } from './api-routes';
import { environment } from '../../../environments/environment';
import { BuildingData, PvCalculationRequest, PvCalculationResponse } from '../interfaces/solar-interfaces';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class SolarService {
  constructor(private http: HttpClient) { }

  getBuildingInsights(latitude: number, longitude: number): Observable<any> {
    const params = new HttpParams()
      .set('location.latitude', latitude.toString())
      .set('location.longitude', longitude.toString())
      .set('requiredQuality', 'LOW')
      .set('key', environment.googleSolarApiKey);

    return this.http.get<BuildingData>(API_ROUTES.SERVICES.INSIGHTS, { params, withCredentials: false });
  }

  getBuildingDataLayers(latitude: number, longitude: number, radiusMeters: number = 30): Observable<any> {
    const params = new HttpParams()
      .set('location.latitude', latitude.toString())
      .set('location.longitude', longitude.toString())
      .set('radiusMeters', radiusMeters)
      .set('requiredQuality', 'LOW')
      .set('key', environment.googleSolarApiKey);

    return this.http.get<BuildingData>(API_ROUTES.SERVICES.DATA_LAYERS, { params, withCredentials: false });
  }

  getTiffImage(imageUrl: string): Observable<Blob> {
    const params = new HttpParams()
      .set('key', environment.googleSolarApiKey);

    return this.http.get<Blob>(imageUrl, { params, withCredentials: false, responseType: 'blob' as 'json' });
  }

  getPVCalculations(request: PvCalculationRequest): Observable<PvCalculationResponse> {
    const payload = JSON.stringify(request);

    return this.http.post<PvCalculationResponse>(
      API_ROUTES.SERVICES.PV_CALCULATIONS,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }
}
